<div #barsgraph class="barsgraph" [ngClass]="theme" (waResizeObserver)="setViewBoxSizes()"
  (mousemove)="toggleSummary($event, true)"
  (mouseout)="toggleSummary($event, false)"
  (mousedown)="$event.preventDefault();">
  <svg class="light" width="100%" height="100%" [attr.viewBox]="viewBoxSize">
    <g class="bars">
      <g class="table" #tablegraph>
        @for (line of range; track line; let i = $index) {
          <g>
            @if (theme != 'export') {
              <line class="guide" x1="32" [attr.y1]="GAP_Y + (separatorIndex * i)" [attr.x2]="viewBoxwidth - gap" [attr.y2]="GAP_Y + (separatorIndex * i)"></line>
            }
            @if (i % intervalLabel.y == 0) {
              <g>
                @switch (dataTypeY) {
                  @case ('percent') {
                    <text class="guide yAxis" [attr.x]="theme == 'export' ? 33: 30" [attr.y]="theme == 'export' ? 20 + (separatorIndex * i) : 15 + (separatorIndex * i)">
                      {{100 - (100 / rangeNumber * i)}}%
                    </text>
                  }
                  @case ('minutes') {
                    <text class="guide yAxis" [attr.x]="theme == 'export' ? 33: 30" [attr.y]="theme == 'export' ? 20 + (separatorIndex * i) : 15 + (separatorIndex * i)">
                      {{(max - ( max / rangeNumber * i)) / 60 | number:'1.0-0'}}
                    </text>
                  }
                  @default {
                    <text class="guide yAxis" [attr.x]="theme == 'export' ? 33: 30" [attr.y]="theme == 'export' ? 20 + (separatorIndex * i) : 15 + (separatorIndex * i)">
                      {{max - ( max / rangeNumber * i) | number:'1.0-0'}}
                    </text>
                  }
                }
              </g>
            }
          </g>
        }
        <line class="axys" [attr.x1]="BOX_SIZE" [attr.y1]="GAP_Y" [attr.x2]="BOX_SIZE" [attr.y2]="viewBoxheigth - 20" />
        @if (theme != 'export') {
          <text class="guide AxisLabel" x="-12" y="47" transform="rotate(-90)" >{{ylabel}}</text>
        }

        @if (showAverage) {
          <ng-container>
            @for (graph of lineObjects; track graph) {
              <ng-container>
                @if (graph[averageValue]) {
                  <line class="average" [ngClass]="graph.type" x1="38" [attr.y1]="getAverageHeight(graph)" [attr.x2]="viewBoxwidth - 21" [attr.y2]="getAverageHeight(graph)" />
                }
              </ng-container>
            }
          </ng-container>
        }

        @for (item of list | slice:position: showNumber + position; track item; let i = $index; let last = $last) {
          <g>
            @if (theme != 'export') {
              <line [ngClass]="{'selected': selectedXItem[id] == item[id]}"
              class="guide" [attr.x1]="labelPosition(i)" [attr.y1]="GAP_Y" [attr.x2]="labelPosition(i)" [attr.y2]="viewBoxheigth - 17"></line>
            }
            @if (i % intervalLabel.x == 0) {
              <text class="guide xAxis" [attr.x]="labelPosition(i)" [attr.y]="theme == 'export' ? viewBoxheigth : viewBoxheigth - 4">{{getXLabel(item)}}</text>
            }
            @for (graph of filteredLineObjects | slice:positionGraph: showNumberGraph + positionGraph; track graph) {
              <ng-container>
                @if (checkShow(graph, item)) {
                  <ng-container>
                    <line
                      class="value"
                      [ngClass]="graph.isActive || !hoverElements || showSummary ? graph.type : 'grey'"
                      [attr.x1]="getXValue(i)"
                      [attr.x2]="getXValue(i + 1)"
                      [attr.y1]="getYValue(item, graph, 'start')"
                      [attr.y2]="getYValue(item, graph, 'end')">
                    </line>
                    @if (last && position < list.length - showNumber) {
                      <line
                        class="value"
                        [ngClass]="graph.isActive || !hoverElements || showSummary ? graph.type : 'grey'"
                        [attr.x1]="getXValue(i + 1)"
                        [attr.x2]="getXValue(i + 2)"
                        [attr.y1]="getYValue(item, graph, 'start', true) || 0"
                        [attr.y2]="getYValue(item, graph, 'end', true) || 0">
                      </line>
                    }
                    @if (selectedXItem[id] == item[id] && theme != 'export' || (showAlwaysDots && showDots(graph, item))) {
                      <circle
                        [attr.r]="radiusCircle"
                        [ngClass]="graph.isActive || !hoverElements || showSummary ? graph.type : 'grey'"
                        [attr.cx]="getXValue(i + 1) || 0"
                        [attr.cy]="getYValue(item, graph, 'end') || 0">
                      </circle>
                    }
                  </ng-container>
                }
              </ng-container>
            }
          </g>
        }

        <line class="axys" [attr.x1]="BOX_SIZE" [attr.y1]="viewBoxheigth - 20" [attr.x2]="viewBoxwidth - gap" [attr.y2]="viewBoxheigth - 20" />
        @if (theme != 'export') {
          <text class="guide AxisLabel" [attr.x]="viewBoxwidth - gap" [attr.y]="viewBoxheigth - 22">{{xlabel | translate}}</text>
        }

        @if (position > 0) {
          <g class="arrow" (click)="previous()" (mousemove)="toggleSummary($event, false, true);">
            <circle r="12" [attr.cx]="55" [attr.cy]="viewBoxheigth / 2" fill="rgba(190,190,190,0.5)"></circle>
            <polygon [attr.points]="getPointsArrow('left')" fill="rgba(20,20,20,0.5)"/>
          </g>
        }
        @if (position < list.length - showNumber) {
          <g class="arrow"  (click)="next()" (mousemove)="toggleSummary($event, false, true);">
            <circle r="12" [attr.cx]="viewBoxwidth - BOX_SIZE" [attr.cy]="viewBoxheigth / 2" fill="rgba(190,190,190,0.5)"></circle>
            <polygon [attr.points]="getPointsArrow('right')" fill="rgba(20,20,20,0.5)"/>
          </g>
        }

        @if (theme != 'export') {
          <ng-container>
            <foreignObject width="25" height="50" [attr.x]="viewBoxwidth - BOX_SIZE" [attr.y]="GAP_Y + 5">
              <div class="zoom-wrapper" (mousemove)="toggleSummary($event, false, true);">
                <span [ngClass]="{'hidden': showNumber <= 1}" class="material-icons-outlined zoom" (click)="zoom('in')">zoom_in</span>
                <span [ngClass]="{'hidden': showNumber >= list.length}" class="material-icons-outlined zoom" (click)="zoom('out')">zoom_out</span>
              </div>
            </foreignObject>
          </ng-container>
        }

      </g>
    </g>
  </svg>
  @if (theme != 'export') {
    <!-- Right graph legend -->
    @if (showLegend && !isSmall) {
      <div #legendgraph class="graph-legend vertical" [ngStyle]="{'width': spaceLegends+'%', 'min-width': spaceLegends+'%'}"
        (mousemove)="toggleSummary($event, false, true);">
        <div class="graph-legend-button" (click)="previous(true)"
          [ngClass]="{'hidden': positionGraph <= 0}">
          <button mat-icon-button aria-label="menu">
            <span class="material-icons-outlined">expand_less</span>
          </button>
        </div>
        @for (graph of filteredLineObjects| slice:positionGraph: showNumberGraph + positionGraph; track graph) {
          <div class="legend-item text bold"
            [ngClass]="graph.isActive || !hoverElements ? graph.type : 'grey'"
            (mouseenter)="toggleActiveGraph(graph, true)"
            (mouseleave)="toggleActiveGraph(graph, false)">
            {{graph.name}}
          </div>
        }
        <div class="graph-legend-button" (click)="next(true)"
          [ngClass]="{'hidden': positionGraph >= (filteredLineObjects.length - showNumberGraph)}">
          <button mat-icon-button aria-label="menu">
            <span class="material-icons-outlined">expand_more</span>
          </button>
        </div>
      </div>
    }
    <!-- Context Legends -->
    @if (showSummary) {
      <div #contextlegend class="filter-contextmenu transparent ctx-validate"
        #contextWrapper [style.left]="contextmenu.x" [style.top]="contextmenu.y">
        <div class="data-body">
          <div class="graph-legend legend-bars vertical">
            <div class="legend-item title">
              <div>{{xlabel | translate}}: {{getXLabel(selectedXItem, true)}}</div>
            </div>
            @for (graph of filteredLineObjects| slice:positionGraph: showNumberGraph + positionGraph; track graph) {
              <div class="legend-item" >
                <div class="circle" [ngClass]="graph.type"></div>
                <div class="wrapper-item">
                  <span class="name-item">{{graph.name | translate}}:&nbsp;</span>
                  @switch (valueType) {
                    @case ('pages') {
                      <span
                        [innerHTML]="graph[graph.items][graph.selectedIndex][graph.valid_property] | pageCount">
                      </span>
                    }
                    @case ('percent') {
                      <span>
                        {{graph[graph.items][graph.selectedIndex][graph.valid_property] ? (graph[graph.items][graph.selectedIndex][graph.valid_property] | number:'1.0-0') : 0 }}%
                      </span>
                    }
                    @default {
                      <span>
                        {{graph[graph.items][graph.selectedIndex][graph.valid_property] ? (graph[graph.items][graph.selectedIndex][graph.valid_property] | number:'1.0-0') : 0 }}
                      </span>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>


